import { render, staticRenderFns } from "./ShipCreate.vue?vue&type=template&id=08704031&scoped=true&"
import script from "./ShipCreate.vue?vue&type=script&lang=js&"
export * from "./ShipCreate.vue?vue&type=script&lang=js&"
import style0 from "./ShipCreate.vue?vue&type=style&index=0&id=08704031&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08704031",
  null
  
)

export default component.exports